import React from 'react';
import PropTypes from 'prop-types';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import metaOverrideSet from './MetaOverrideSet';
import {
  ClientRiskToleranceLayout,
} from './ClientRiskToleranceLayout';


export const ClientRiskTolerance = ({ resource }) => {
  return (<MetaFormInline
    metaOverrideSet={metaOverrideSet}
    resource={resource}
    layout={ClientRiskToleranceLayout}
    LayoutProps={{
      resource,
    }}
    noIndividualSubmitButtons
    noIndividualDeleteButtons
    padding={'none'}
  />);
};

ClientRiskTolerance.propTypes = {
  resource: PropTypes.object.isRequired, // a riskToleranceClient resource
};
